import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Chip } from '@mui/material'

import { formatMoney } from '~/src/utils/formatMoney'

type TContainerOrderItem = {
  name: string
  images: string[]
  refNo?: string
  price: number
  maker: string
  carName: string
  modelCode: string
}

interface IContainerOrderItemInfoProps {
  data: TContainerOrderItem
}

/**
 * ContainerOrderItem
 *
 * @param __namedParameters IContainerOrderItemProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const ContainerOrderItemInfo: React.FC<IContainerOrderItemInfoProps> = ({
  data,
}): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Box width={'100%'}>
      <Box marginBottom={1}>
        <Chip
          label="Used Car"
          sx={{
            height: '21px',
            borderRadius: '4px',
            fontWeight: 'bold',
            fontSize: '11px',
            color: '#222222',
            '& 	.MuiChip-label': {
              paddingTop: '2px',
              paddingX: '4px',
            },
          }}
        />
      </Box>
      <Box display={'flex'} alignItems={'center'} marginBottom={2} border={'1px solid #D4D4D4'}>
        <Box
          width={'170px'}
          borderRight={'1px solid #D4D4D4'}
          paddingLeft={1}
          paddingY={'2px'}
          sx={{ background: '#F7F7F7' }}
        >
          <Typography
            sx={{
              minWidth: '95px',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: 500,
              letterSpacing: '0.17px',
              color: '#666666',
            }}
          >
            Ref No.
          </Typography>
        </Box>
        <Box paddingLeft={1} paddingY={'2px'}>
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: '20px',
              letterSpacing: '0.15px',
              color: '#222222',
            }}
          >
            XXXXX
          </Typography>
        </Box>
      </Box>
      <Box marginBottom={2.5}>
        <Typography
          component="h2"
          sx={{
            fontSize: '24px',
            lineHeight: '31.2px',
            fontWeight: 'bold',
            color: '#222222',
          }}
        >
          {data.name}
        </Typography>
      </Box>
      <Box
        display={'flex'}
        height={'52px'}
        alignItems={'center'}
        paddingX={1}
        sx={{ background: '#F7F7F7' }}
      >
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '14px',
            lineHeight: '14px',
            fontWeight: 400,
            color: '#222222',
            textAlign: 'left',
          }}
        >
          Original price
        </Typography>

        <Box marginLeft={2}>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '20px',
              lineHeight: '20px',
              fontWeight: 700,
              color: '#F23D3D',
            }}
          >
            ¥ 50,000
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
